/**
 * audit-schema.ts — contract การอ่าน audit log (T090 history, T099 audit queue)
 * audit_logs เป็น append-only (ไม่มี API แก้/ลบ ใน Phase 1)
 */
import { z } from 'zod';
import { uuid, dateKey, pagination } from './schemas.js';

export const auditListFilter = z
  .object({
    entityTable: z.string().trim().max(80).optional(),
    entityId: uuid.optional(),
    action: z.enum(['create', 'update', 'override', 'revision', 'reversal', 'delete_denied']).optional(),
    actorId: uuid.optional(),
    from: dateKey.optional(),
    to: dateKey.optional(),
  })
  .and(pagination);
export type AuditListFilter = z.infer<typeof auditListFilter>;

/** แถว audit ที่ส่งให้ UI (old/new เป็น jsonb ตามที่บันทึกไว้) */
export interface AuditLogRow {
  id: string;
  action: string;
  entityTable: string;
  entityId: string | null;
  actorId: string | null;
  reason: string | null;
  requestId: string | null;
  createdAt: string;
  oldData: unknown;
  newData: unknown;
}

/** ฟิลด์ที่เปลี่ยนระหว่าง old → new (ใช้แสดงประวัติแบบอ่านง่าย) */
export function diffFields(
  oldData: unknown,
  newData: unknown,
): { field: string; from: unknown; to: unknown }[] {
  const o = (oldData ?? {}) as Record<string, unknown>;
  const n = (newData ?? {}) as Record<string, unknown>;
  const out: { field: string; from: unknown; to: unknown }[] = [];
  for (const key of Object.keys(n)) {
    const before = o[key];
    const after = n[key];
    if (JSON.stringify(before ?? null) !== JSON.stringify(after ?? null)) {
      out.push({ field: key, from: before ?? null, to: after ?? null });
    }
  }
  return out;
}
